export default "__VITE_ASSET__fac133d6__"